<app-input-select
  idField="codice"
  labelField="descrizione"
  [list]="tipologie"
  [name]="name"
  label="Tipo"
  icon="edit_location_alt"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
  placeholder="Seleziona una tipologia"
>
</app-input-select>
